import { usePrivateFileControl } from '@modules/file-menagement';
import { Tooltip, styled } from '@mui/material';
import { useState } from 'react';
import { AIFilesType } from 'src/@types/ai';
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';

export const GeneratedImage = ({ file }: { file: AIFilesType }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const { translate } = useLocales();

  const { download } = usePrivateFileControl({
    _id: file.data.id,
    name: file.data.filename,
    mimeType: file.data.mimeType,
  });

  const handleDownload = async () => {
    setIsDownloading(true);
    download();
    setIsDownloading(false);
  };

  return (
    <StyledImageContainer>
      <StyledImageActions className="actions">
        {isDownloading ? (
          <DownloadIcon icon="eos-icons:loading" />
        ) : (
          <Tooltip
            title={translate('shared.download.download_image')}
            placement="top"
          >
            <DownloadIcon icon="tabler:download" onClick={handleDownload} />
          </Tooltip>
        )}
      </StyledImageActions>
      <img src={file.data.url} alt={file.data.filename} />
    </StyledImageContainer>
  );
};

const StyledImageContainer = styled('div')(() => ({
  position: 'relative',
  overflow: 'hidden',
  '& .actions': {
    display: 'none',
  },
  '&:hover': {
    '& .actions': {
      display: 'flex',
    },
  },
}));

const StyledImageActions = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(1),
  right: theme.spacing(1),
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 10,

  '& .iconify': {
    color: theme.palette.text.secondary,
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.text.primary,
    },
  },
}));

const DownloadIcon = styled(Iconify)(({ theme }) => ({
  width: theme.spacing(3),
  height: theme.spacing(3),
  padding: theme.spacing(0.5),
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.background.default,
}));
